import { createFileRoute } from "@tanstack/react-router";
import { MoodForm } from "@/components/onboarding/mood-form";
import { OnboardingLayout } from "@/components/onboarding/onboarding-layout";

export const Route = createFileRoute("/onboarding/humor")({
	component: OnboardingStep4,
});

function OnboardingStep4() {
	return (
		<OnboardingLayout>
			<MoodForm />
		</OnboardingLayout>
	);
}
